
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education/[section]/page/[pageNum]",
      function () {
        return require("private-next-pages/education/[section]/page/[pageNum].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education/[section]/page/[pageNum]"])
      });
    }
  